import * as React from 'react';

export const Link: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<g id="link-2">
				<g id="Vector">
					<path
						d="M11.5271 3.8997C13.7091 1.7127 17.2301 1.3177 19.6621 3.2197C22.5751 5.4977 22.7661 9.7427 20.2351 12.2797L18.8121 13.7047C18.4191 14.0987 17.7831 14.0987 17.3901 13.7047C16.9971 13.3117 16.9971 12.6727 17.3901 12.2797L18.8121 10.8537C20.4671 9.1967 20.3771 6.4417 18.5401 4.9037C16.9131 3.5407 14.4711 3.8007 12.9721 5.3027L11.6991 6.5777C11.3071 6.9717 10.6691 6.9717 10.2771 6.5777C9.8841 6.1847 9.8801 5.5497 10.4541 4.9747L11.5271 3.8997Z"
						fill="currentColor"
					/>
					<path
						d="M13.293 9.293L9.293 13.293C8.902 13.684 8.902 14.316 9.293 14.707C9.488 14.902 9.744 15 10 15C10.256 15 10.512 14.902 10.707 14.707L14.707 10.707C15.098 10.316 15.098 9.684 14.707 9.293C14.316 8.902 13.684 8.902 13.293 9.293Z"
						fill="currentColor"
					/>
					<path
						d="M12.2803 17.3965L11.0063 18.6675C9.5053 20.1645 7.0583 20.4225 5.4303 19.0655C3.5913 17.5335 3.5003 14.7875 5.1573 13.1345L6.5823 11.7145C6.9753 11.3225 6.9753 10.6865 6.5823 10.2935C6.1893 9.9025 5.5513 9.9025 5.1573 10.2935L3.8823 11.5665C1.7103 13.7325 1.3293 17.2165 3.2073 19.6405C5.4783 22.5735 9.7383 22.7715 12.2803 20.2375L13.7053 18.8175C14.0983 18.4245 14.0983 17.7895 13.7053 17.3965C13.3113 17.0035 12.6743 17.0035 12.2803 17.3965Z"
						fill="currentColor"
					/>
				</g>
			</g>
		</svg>
	);
};
